import { useEffect, useState, useContext } from 'react';

import { AppContext } from '@powdr/context';
import { isBuildTime } from '@powdr/utils';

export const useIsFooterLogoInView = () => {
  const { isMobile } = useContext(AppContext);
  const [isFooterLogoInView, setFooterLogoInView] = useState(false);

  useEffect(() => {
    if (!isMobile || isBuildTime()) {
      setFooterLogoInView(false);
      return undefined;
    }

    const footerLogo = document.querySelector('.footer-logo');
    if (!footerLogo) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => setFooterLogoInView(entry.isIntersecting),
      { threshold: 0 },
    );

    observer.observe(footerLogo);

    return () => observer.disconnect();
  }, [isMobile]);

  return isFooterLogoInView;
};
